import React from 'react'
import { TimeUtils } from '@front/volcanion/utils'
import { IconUtils } from '@front/squirtle/utils'

import moment from 'moment'

import { TableCell, Icon, Tooltip, Box } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const DateTimeRow = ({ row }) => {
  const requestedAt = moment.utc(TimeUtils.getDetailsMomentFront(row?.requestedAt, row?.source)).local().format('DD/MM/YY HH:mm')
  const { icon, tooltip } = IconUtils.getScheduleTypeIcon(row?.schedule_type)
  return (
    <TableCell padding='none' sx={{ minWidth: 150 }}>
      <Box display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
        <Tooltip title={tooltip} placement='left'>
          <Icon color='primary' fontSize={'small'}>{icon}</Icon>
        </Tooltip>
      </Box>
      <Box>
        <TextCell fontSize={13} value={requestedAt} noWrap width='98%' />
      </Box>
    </TableCell>
  )
}

export default React.memo(DateTimeRow)
